/**
 * naboo's `decision_reason` codes as an operator reads them.
 *
 * The code is naboo's internal vocabulary: `best_path_on_filtered` told the reader nothing, and the
 * CTX-738 codes (`hold_nexthop_unresolved`, …) read like log lines. The dashboard translates them
 * here, in one place, and keeps the raw code available as a tooltip for support. naboo stays the
 * source of the codes, so an unknown or free-text value (outbound rows carry
 * "Outbound announcement to …") is shown as it arrives rather than hidden.
 */
const DECISION_LABELS: Record<string, string> = {
  best_path_on_filtered: 'Best path (after rule filters)',
  hold_persistence: 'Held: no current path, persistence on',
  hold_nexthop_unresolved: 'Held: next hop does not resolve',
  nexthop_unresolved: 'Not injected: next hop does not resolve',
  delete_explicit_withdraw: 'Withdrawn by the peer',
  delete_no_candidates: 'Withdrawn: no path left',
  // Older naboo builds spell it in the singular.
  delete_no_candidate: 'Withdrawn: no path left',
  delete_nexthop_unresolved: 'Withdrawn: next hop does not resolve'
};

/** The label for a decision code, the code itself when it is not a known one, or null when absent. */
export function decisionLabel(code: string | null | undefined): string | null {
  const trimmed = code?.trim();
  if (!trimmed) {
    return null;
  }
  return DECISION_LABELS[trimmed] ?? trimmed;
}
